import { render, staticRenderFns } from "./NewsletterTemplateModal.vue?vue&type=template&id=0ef3679a&scoped=true&"
import script from "./NewsletterTemplateModal.vue?vue&type=script&lang=js&"
export * from "./NewsletterTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef3679a",
  null
  
)

export default component.exports